export default "__VITE_ASSET__C9WV84tj__"